var __DEV__ = process.env.NODE_ENV !== 'production';

var state = {
  bootstrapTime: null,
  lastHiddenStart: Number.MIN_SAFE_INTEGER
};
export { __DEV__, state };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@elastic/apm-rum-core/dist/es/state.js
// module id = 226
// module chunks = 0